import { colors as themeColors } from '../utils/theme';
import React from "react";
import TextField from "@mui/material/TextField";

const FloatingLabelInput = React.memo(
  ({
    label,
    name,
    type = "text",
    value,
    onChange,
    disabled = false,
    required = false,
    error,
    helperText,
    InputProps,
    sx,
    ...rest
  }) => {
    return (
      <TextField
        id={name}
        name={name}
        type={type}
        value={value || ""}
        onChange={onChange}
        disabled={disabled}
        required={required}
        label={label}
        variant="outlined"
        size="small"
        error={error}
        helperText={helperText}
        InputLabelProps={{
          sx: {
            "& .MuiFormLabel-asterisk": { color: themeColors.error.dark }, // red asterisk
            fontSize: "0.85rem",
            transform: "translate(14px, 10px) scale(1)",
            "&.MuiInputLabel-shrink": {
              transform: "translate(14px, -9px) scale(0.85)",
            },
          },
        }}
        InputProps={{
          ...InputProps,
          sx: {
            fontSize: "0.9rem",
            borderRadius: 2,
            backgroundColor: themeColors.neutral.surface,
            transition: "border-color 0.2s ease, box-shadow 0.2s ease",
            "& input": {
              padding: "10.5px 14px",
            },
            "& fieldset": {
              borderColor: "#d0d7de",
            },
            "&:hover fieldset": {
              borderColor: "#b3bfc9",
            },
          },
        }}
        sx={{
          width: "100%",
          height: 38,
          ...sx,
        }}
        {...rest}
      />
    );
  }
);

export default FloatingLabelInput;